import * as React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Navigation, Pagination, Autoplay } from 'swiper';
import EFPicture from '@elem/compCommon/EFPicture';
import styled from './index.module.scss';

const cards = [
    {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717062331202/dp3_pc_1.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717062335892/dp3_h5_1.jpg',
    },
    {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717139654259/dp3_pc_2.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717139659918/dp3_h5_2.jpg',
    },
    {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717139824659/dp3_pc_3.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717139831474/dp3_h5_3.jpg',
    },
    {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717139926500/dp3_pc_4.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717139932574/dp3_h5_4.jpg',
    },
];

export default function Gallery() {
    const [gap, setGap] = React.useState(24);

    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            const winW = window?.innerWidth;
            setGap(winW > 1440 ? 24 : winW > 1024 ? 16 : 10);
        }
    }, []);

    return (
        <div className={styled.gallery}>
            <Swiper
                className={'swiper-box'}
                modules={[Scrollbar, Navigation, Pagination, Autoplay]}
                navigation={true}
                pagination={true}
                loop={true}
                spaceBetween={gap}
                centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }}
            >
                {cards?.map((card, k: number) => {
                    return (
                        <SwiperSlide className={`swiper-item`} key={k}>
                            <div className="card-img">
                                <EFPicture src={card.pc} srcMobile={card.h5} alt={'slide image'} />
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
}
